module.exports = __webpack_public_path__ + "1.4.15-unryo/img/tomcat.83978bf7.svg";